import React, { FC, ReactElement, useMemo } from 'react';
import { useHistory } from 'react-router-dom';
import styles from './index.less';

interface IProps {
  width?: number,
  height?: number,
  item?: any
}

const ActivityFixItem: FC<IProps> = (props:IProps): ReactElement => {

  const {width, height, item} = props
  const history = useHistory()
  
  const customStyle = useMemo(()=>{
    let obj:any = {}
    if(width)
      obj['width'] = width+'rem'
    if(height)
      obj['height'] = height+'rem'
    return {
      ...obj,
      marginLeft: '0.1rem',
      marginRight: '0.1rem',
    }
  }, [width, height])

  const imgStyle = useMemo(()=>{
    let obj:any = {}
    if(height)
      obj['height'] = `${height-0.7}rem` 
    return obj
  }, [height])
  //console.log(imgStyle)

  const itemClick = ()=>{
    if(item && item.infoId){
      history.push(`/activity/${item.catalogType}/detail/${item.infoId}`)
    }
  }

  return (
    <div className={styles.fixItem} style={customStyle}>
      <div className={styles.img} onClick={itemClick} style={imgStyle}>
        <img alt={item.name} src={item.coverImg}></img>
      </div>
      <div className={styles.title}>
        <a className="abtn" onClick={itemClick}>{item.name}</a>
      </div>
    </div>
  )
}

export default ActivityFixItem